import React from 'react';
import { Button, Space, Divider } from 'antd';
import { D214Mode } from '../hooks/useD214Mode';

interface ActionBarProps {
  mode: D214Mode;
  isEditing: boolean;
  hasPrev: boolean;
  hasNext: boolean;
  saving: boolean;
  hasRecord: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
  onSearch: () => void;
  onAdd: () => void;
  onSave: () => void;
  onEdit: () => void;
  onCancel: () => void;
  onDelete: () => void;
  onExit: () => void;
}

const ActionBar: React.FC<ActionBarProps> = ({
  mode, isEditing, hasPrev, hasNext, saving, hasRecord,
  canCreate, canEdit, canDelete,
  onFirst, onPrev, onNext, onLast, onSearch,
  onAdd, onSave, onEdit, onCancel, onDelete, onExit,
}) => {
  return (
    <div className="d214-action-bar">
      <Space wrap>
        {/* Navigation */}
        <Button size="small" onClick={onFirst} disabled={isEditing || !hasPrev}>首筆</Button>
        <Button size="small" onClick={onPrev} disabled={isEditing || !hasPrev}>上一筆</Button>
        <Button size="small" onClick={onNext} disabled={isEditing || !hasNext}>下一筆</Button>
        <Button size="small" onClick={onLast} disabled={isEditing || !hasNext}>末筆</Button>
        <Divider type="vertical" />

        {/* Search */}
        <Button size="small" onClick={onSearch} disabled={isEditing}>查詢</Button>
        <Divider type="vertical" />

        {/* Add / Save */}
        {!isEditing ? (
          <Button size="small" type="primary" onClick={onAdd} disabled={!canCreate}>新增</Button>
        ) : (
          <Button size="small" type="primary" onClick={onSave} loading={saving} disabled={!canCreate && mode === 'add'}>
            存檔
          </Button>
        )}

        {/* Edit / Cancel */}
        {!isEditing ? (
          <Button size="small" onClick={onEdit} disabled={!canEdit || !hasRecord}>修改</Button>
        ) : (
          <Button size="small" onClick={onCancel}>還原</Button>
        )}

        {/* Delete */}
        <Button size="small" danger onClick={onDelete} disabled={!canDelete || isEditing || !hasRecord}>
          刪除
        </Button>
        <Divider type="vertical" />

        {/* Exit */}
        <Button size="small" onClick={onExit}>離開</Button>
      </Space>
    </div>
  );
};

export default ActionBar;
